import {css} from 'lit';
export const styles = css`:host {
  display: inline-flex;
  border: 1px solid transparent;
  border-radius: 4px;
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;
}

:host(:not([outline])[theme='primary']) {
  --text-primary: #fff;
  --background-primary: var(--primary);

  background-color: var(--background-primary);
  color: var(--text-primary);
}

:host([outline][theme='primary']) {
  --text-primary: var(--primary);
  --border-color: var(--primary);

  border-color: var(--border-color);
  color: var(--text-primary);
}

:host(:not([outline])[theme='secondary']) {
  --text-primary: #fff;
  --background-primary: var(--secondary);

  background-color: var(--background-primary);
  color: var(--text-primary);
}

:host([outline][theme='secondary']) {
  --text-primary: var(--secondary);
  --border-color: var(--secondary);

  border-color: var(--border-color);
  color: var(--text-primary);
}

:host(:not([outline])[theme='success']) {
  --text-primary: #fff;
  --background-primary: var(--success);

  background-color: var(--background-primary);
  color: var(--text-primary);
}

:host([outline][theme='success']) {
  --text-primary: var(--success);
  --border-color: var(--success);

  border-color: var(--border-color);
  color: var(--text-primary);
}

:host(:not([outline])[theme='info']) {
  --text-primary: #fff;
  --background-primary: var(--info);

  background-color: var(--background-primary);
  color: var(--text-primary);
}

:host([outline][theme='info']) {
  --text-primary: var(--info);
  --border-color: var(--info);

  border-color: var(--border-color);
  color: var(--text-primary);
}

:host(:not([outline])[theme='warning']) {
  --text-primary: #fff;
  --background-primary: var(--warning);

  background-color: var(--background-primary);
  color: var(--text-primary);
}

:host([outline][theme='warning']) {
  --text-primary: var(--warning);
  --border-color: var(--warning);

  border-color: var(--border-color);
  color: var(--text-primary);
}

:host(:not([outline])[theme='danger']) {
  --text-primary: #fff;
  --background-primary: var(--danger);

  background-color: var(--background-primary);
  color: var(--text-primary);
}

:host([outline][theme='danger']) {
  --text-primary: var(--danger);
  --border-color: var(--danger);

  border-color: var(--border-color);
  color: var(--text-primary);
}

:host(:not([outline])[theme='muted']) {
  --text-primary: #fff;

  background-color: var(--dark-bg-secondary);
  color: var(--text-primary);
}

:host([outline][theme='muted']) {
  border-color: var(--border-dark-secondary);
  color: var(--dark-text-secondary);
}

:host([layout='sm']) {
  --font-size-primary: 12px;

  padding: 2px 6px;
  font-size: var(--font-size-primary);
}

:host([layout='md']) {
  --font-size-primary: 14px;

  padding: 6px 10px;
  font-size: var(--font-size-primary);
}

:host([layout='lg']) {
  --font-size-primary: 16px;

  padding: 8px 14px;
  font-size: var(--font-size-primary);
}
`;
export default styles;
